import { useState, useCallback, useEffect } from 'react';
import IS_BROWSER from '../isBrowser/index.js';

function useDelayedScript(url, async, defer) {
  if (async === void 0) {
    async = true;
  }
  if (defer === void 0) {
    defer = true;
  }
  var _a = useState(false),
    isScriptLoaded = _a[0],
    setIsScriptLoaded = _a[1];
  var loadScript = useCallback(function (src) {
    if (typeof document === 'undefined') return;
    var existingScript = document.querySelector("script[src=\"".concat(src, "\"]"));
    if (existingScript) {
      if (existingScript.getAttribute('data-loaded') === 'true') {
        setIsScriptLoaded(true);
      } else {
        existingScript.addEventListener('load', function () {
          existingScript.setAttribute('data-loaded', 'true');
          setIsScriptLoaded(true);
        });
      }
      return;
    }
    var script = document.createElement('script');
    script.src = src;
    script.async = async;
    script.defer = defer;
    script.addEventListener('load', function () {
      script.setAttribute('data-loaded', 'true');
      setIsScriptLoaded(true);
    });
    script.addEventListener('error', function () {
      console.error("Error loading script: ".concat(src));
    });
    if (document.body) {
      document.body.appendChild(script);
    }
  }, [async, defer]);
  useEffect(function () {
    IS_BROWSER && loadScript(url);
  }, [url, loadScript]);
  return isScriptLoaded;
}

export { useDelayedScript as default };
//# sourceMappingURL=index.js.map
